export default __webpack_public_path__ + "static/media/money.e49fd106.svg";